import {
  subDays,
  startOfWeek,
  startOfMonth,
  startOfToday,
  startOfYear,
  endOfToday,
  endOfYesterday,
  startOfYesterday,
} from 'date-fns';

import { PERIODS } from '../enums';
import { FACTORY_TYPE } from '$fbusiness/enums/options/factoryType';
import { B2B_PATHS, B2C_PATHS } from '../enums/routes';

export const getDateRangeFromPeriod = (period) => {
  switch (period) {
    case PERIODS.TODAY:
      return [startOfToday(), endOfToday()];
    case PERIODS.YESTERDAY:
      return [startOfYesterday(), endOfYesterday()];
    case PERIODS.LAST_7_DAYS:
      const last7 = subDays(startOfToday(), 7);
      return [last7, endOfToday()];
    case PERIODS.LAST_30_DAYS:
      const last30 = subDays(startOfToday(), 30);
      return [last30, endOfToday()];
    case PERIODS.LAST_365_DAYS:
      const last365 = subDays(startOfToday(), 365);
      return [last365, endOfToday()];
    case PERIODS.THIS_WEEK:
      return [startOfWeek(startOfToday()), endOfToday()];
    case PERIODS.THIS_MONTH:
      return [startOfMonth(startOfToday()), endOfToday()];
    case PERIODS.THIS_YEAR:
      return [startOfYear(startOfToday()), endOfToday()];
    default:
      return [null, endOfToday()];
  }
};

export const generateRandomOrderId = () => {
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const letter = letters.charAt(Math.floor(Math.random() * letters.length));
  const number = Math.floor(Math.random() * 9999);
  return `${letter}${number}`;
};

export const canFactoryAccess = (currentState, path, route?: any) => {
  // Check superSuperAdminOnly flag on route
  if (route?.superSuperAdminOnly && !currentState?.isSuperSuperAdmin) {
    return false;
  }
  if (currentState?.settings?.type !== FACTORY_TYPE.CONSUMER) {
    if (B2C_PATHS.includes(path)) return false;
    return true;
  }
  if (B2B_PATHS.includes(path)) return false;
  return true;
};
